module.exports = __webpack_public_path__ + "static/media/logo-up.ed9d94cf.png";